<div class="dx-grid-toolbar">
  <div class="dx-grid-toolbar__top  dx-grid-toolbar__top--controls">
    <!-- pressed -->
    <ng-container *ngFor="let item of buttons">
      <button class="dx-grid-toolbar__btn dx-grid-toolbar__btn--tool dx-grid-toolbar__top--control"
              [ngClass]="getBtnClass(item)"
              [disabled]="item.disabled"
              [title]="item.title"
              (click)="onToolbarBtnClick(item)">
        <span *ngIf="!item.icon">{{item.title}}</span>
        <img class="dx-grid-toolbar__btn-icon" [src]="item.icon" alt="">
      </button>
    </ng-container>

  </div>
</div>
